var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92622 14.8232L5.38065 16.8079C4.93844 17.0554 4.40932 16.671 4.50806 16.174L5.29983 12.1885C5.42057 11.5807 5.21687 10.9539 4.76192 10.5332L1.77829 7.77427C1.4062 7.4302 1.60829 6.80816 2.11155 6.74847L6.14685 6.26988C6.76212 6.19691 7.29531 5.80954 7.55484 5.24693L9.2572 1.55664C9.46947 1.09649 10.1235 1.09649 10.3357 1.55665L12.0381 5.24693C12.2976 5.80954 12.8308 6.19691 13.4461 6.26988L17.4814 6.74847C17.9847 6.80816 18.1867 7.4302 17.8147 7.77427L14.831 10.5332C14.3761 10.9539 14.1724 11.5807 14.2931 12.1885L15.0849 16.174C15.1836 16.671 14.6545 17.0554 14.2123 16.8079L10.6667 14.8232C10.126 14.5206 9.46692 14.5206 8.92622 14.8232Z",
    stroke: "#EAAC0C",
    strokeWidth: 1.18778
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.775f54f24e8287f8c216342dd24e80dd.svg";
export { ForwardRef as ReactComponent };